var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isRouterAlive
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          _c(
            "a-config-provider",
            { attrs: { locale: _vm.zh_CN } },
            [
              _c("router-view", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageInit,
                    expression: "pageInit"
                  }
                ]
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.pageInit,
                  expression: "!pageInit"
                }
              ],
              staticClass: "page-wait-container"
            },
            [
              _c("a-spin", { attrs: { spinning: true } }),
              _c("div", [_vm._v("正在加载资源")]),
              _c("div", [_vm._v("如果2分钟还没进入页面，或许可以刷新试试")])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }